import * as Yup from 'yup';
import { conditionalRequired, getDefaultItemId } from 'src/components/formik-utils';

export const validationSchema = (myId) => {
  const isRequired = myId === 0;

  const schema = Yup.object({
    nameField: conditionalRequired(Yup.string(), 'Tên khóa phải có', isRequired),
    codeField: conditionalRequired(Yup.string(), 'Mã khóa phải có', isRequired)
  });
  return schema;
};

export const initialValues = {
  nameField: null, 
  codeField: null
};

export const handleSubmitted = async (
  values,
  item,
  apiCreate,
  apiUpdate,
  apiDelete,
) => {
  const myId = getDefaultItemId(item);
  if(0 < myId){
    values.id = myId;
    if (values.isVerified) {
      await apiDelete(values);
    } else {
      await apiUpdate(values);
    }
  }else{
    await apiCreate(values);
  }
};

// export const initialValues = (formik, item) => {
//   if(!formik) return;
//   const myId = getDefaultItemId(item);

//   if(0 < myId){
//     formik.setFieldValue('id', myId);

//   }else{
//     formik.setFieldValue('nameField', null);
//     formik.setFieldValue('codeField', null);
//     // formik.setFieldValue('openingField', null);
//     // formik.setFieldValue('closingField', null);
//   }
// };
